// extracted by mini-css-extract-plugin
module.exports = {"primary":"#d86077","mobileMaxSize":"575px"};